import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { Scale } from 'lucide-react';
export function CostOfInaction() {
  const rows = [{
    sin: 'Buscar actividades en internet que no encajan',
    costo: 'Horas de tu tiempo cada semana'
  }, {
    sin: 'Material en inglés o demasiado infantil',
    costo: 'Tu familiar lo abandona en dos días'
  }, {
    sin: 'Sin sistema de seguimiento',
    costo: 'No sabés si está mejorando o empeorando'
  }, {
    sin: 'Sin referencias culturales argentinas',
    costo: 'Las actividades no conectan emocionalmente'
  }, {
    sin: 'Sin guía de alertas',
    costo: 'Tardás en detectar señales que importan'
  }, {
    sin: 'El próximo mes volvés a empezar de cero',
    costo: 'El mismo ciclo, sin avance real'
  }];
  return <section className="py-20 px-4 bg-ivory" data-id="element-40">
      <div className="max-w-4xl mx-auto" data-id="element-41">
        <div className="text-center mb-12" data-id="element-42">
          <h2 className="text-3xl md:text-5xl font-bold text-blue-900 flex items-center justify-center gap-4" data-id="element-43">
            <Scale className="w-10 h-10 text-amber-500" data-id="element-44" />
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="bg-cream rounded-3xl p-6 md:p-10 border border-stone-200 shadow-sm mb-16" data-id="element-45">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-8" data-id="element-46">
            <div className="hidden md:block font-bold text-slate-500 border-b border-stone-200 pb-4" data-id="element-47">
              Sin Megapack
            </div>
            <div className="hidden md:block font-bold text-red-600 border-b border-stone-200 pb-4" data-id="element-48">
              Costo real
            </div>

            {rows.map((row, i) => <Fragment key={i} data-id="element-49">
                <div className="flex items-start gap-3 md:border-b md:border-stone-200 md:pb-4" data-id="element-50">
                  <span className="text-slate-400 mt-1 hidden md:inline" data-id="element-51">
                    ➖
                  </span>
                  <span className="text-slate-700 font-medium" data-id="element-52">{row.sin}</span>
                </div>
                <div className="flex items-start gap-3 border-b border-stone-200 pb-6 md:pb-4 mb-2 md:mb-0" data-id="element-53">
                  <span className="text-red-500 mt-1" data-id="element-54">💸</span>
                  <span className="text-red-700 font-bold" data-id="element-55">{row.costo}</span>
                </div>
              </Fragment>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-blue-900 text-white p-8 md:p-12 rounded-3xl shadow-xl" data-id="element-56">
          <p className="text-xl md:text-2xl text-blue-100 mb-6" data-id="element-57">
            La mente de tu familiar no puede esperar.
          </p>
          <p className="text-3xl md:text-4xl font-bold text-amber-400 leading-tight italic" data-id="element-58">
            "La mente que se ejercita no envejece. Evoluciona." 🧠
          </p>
        </motion.div>
      </div>
    </section>;
}